export default "__VITE_ASSET__CdybPcL7__"